import { render, staticRenderFns } from "./CrossdomainAllowlistManagement.vue?vue&type=template&id=1eebe93a"
import script from "./CrossdomainAllowlistManagement.vue?vue&type=script&lang=ts"
export * from "./CrossdomainAllowlistManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports